import { Content as RadContent } from '@radix-ui/react-accordion';

import CallOutCard from 'layout/header/components/CallOutCard';
import Menu from 'layout/header/components/Menu';
import ResourceCard from 'layout/header/components/ResourceCard';
import { mobileMenuItemStyle } from 'layout/header/styles';

import { hasArrayValues } from 'utils/array/arrays';

import type { FC } from 'react';

const Content: FC<MegaMenu> = ({ menu, callOutCard, resource }) => {
  const hasMultipleMenus = hasArrayValues(menu) && menu.length > 1;
  const direction = hasMultipleMenus ? 'row' : 'column';

  return (
    <RadContent className="overflow-hidden data-[state=closed]:animate-accordionSlideUp data-[state=open]:animate-accordionSlideDown">
      <div className="flex w-full flex-col gap-3 rounded-xl border border-white/10 bg-testimonialCardGradient p-4 pb-[30px]">
        {callOutCard?.heading && (
          <div className="w-full">
            <CallOutCard {...callOutCard} />
          </div>
        )}
        {hasArrayValues(menu) && (
          <div className={mobileMenuItemStyle({ direction, multiColumn: menu.length > 1 })}>
            {menu.map(menuItem => (
              <div key={menuItem.label}>
                <Menu {...menuItem} direction={direction} isMobile />
              </div>
            ))}
          </div>
        )}
        {resource && <ResourceCard {...(resource.value?.data || {})} />}
      </div>
    </RadContent>
  );
};

export default Content;
